var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content-view"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{staticClass:"content"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }